/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDim4CrossIcon16Light } from './ArrowDim4CrossIcon16Light';
import { ArrowDim4CrossIcon16Regular } from './ArrowDim4CrossIcon16Regular';
import { ArrowDim4CrossIcon16Solid } from './ArrowDim4CrossIcon16Solid';
import { ArrowDim4CrossIcon20Light } from './ArrowDim4CrossIcon20Light';
import { ArrowDim4CrossIcon20Regular } from './ArrowDim4CrossIcon20Regular';
import { ArrowDim4CrossIcon20Solid } from './ArrowDim4CrossIcon20Solid';
import { ArrowDim4CrossIcon24Regular } from './ArrowDim4CrossIcon24Regular';
import { ArrowDim4CrossIcon24Solid } from './ArrowDim4CrossIcon24Solid';
import { ArrowDim4CrossIcon32Regular } from './ArrowDim4CrossIcon32Regular';
import { ArrowDim4CrossIcon64Regular } from './ArrowDim4CrossIcon64Regular';
var sizes = {
    16: {
        light: ArrowDim4CrossIcon16Light,
        regular: ArrowDim4CrossIcon16Regular,
        solid: ArrowDim4CrossIcon16Solid,
    },
    20: {
        light: ArrowDim4CrossIcon20Light,
        regular: ArrowDim4CrossIcon20Regular,
        solid: ArrowDim4CrossIcon20Solid,
    },
    24: {
        regular: ArrowDim4CrossIcon24Regular,
        solid: ArrowDim4CrossIcon24Solid,
    },
    32: {
        regular: ArrowDim4CrossIcon32Regular,
    },
    64: {
        regular: ArrowDim4CrossIcon64Regular,
    },
};
export var ArrowDim4CrossIcon = forwardRef('ArrowDim4CrossIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
